import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'drift-ui';
import styles from './BankingErrorScreen.scss';

interface BankingErrorScreenProps {
  onRefresh: () => void;
}

export const BankingErrorScreen: FC<BankingErrorScreenProps> = ({ onRefresh }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.errorContainer} data-testid="banking-kyb-error-screen">
      <div className={styles.errorContent}>
        <p className={styles.errorTitle}>{t('digital_onboarding.banking.post_submission_screens.error_submitting')}</p>
        <p className={styles.errorSubtitle}>
          {t('digital_onboarding.banking.post_submission_screens.refresh_to_continue')}
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <Button variant="contained" color="primary" onClick={onRefresh}>
          {t('Refresh')}
        </Button>
      </div>
    </div>
  );
};
